import { useContext } from "react"
import "bootstrap/dist/css/bootstrap.min.css";
import { useForm } from "react-hook-form"
import { useState } from "react";
import { Alert, Card, Button, Form } from "react-bootstrap"
import { UserContext } from "../context/UserContext";
import { SENSEI_BACKEND_ENVS, BuildSenseiAuthURL } from "../helpers/URLHelper";
import { useSearchParams } from "react-router-dom";

const SENSEI_AUTH_APP_CODE = "TSD"

export default function Login() {
    const [errorMessage, setErrorMessage] = useState("")
    const [showErrorAlert, setShowErrorAlert] = useState(false)
    const { setRefreshToken, setToken } = useContext(UserContext)
    const [searchParams] = useSearchParams()

    const { register, handleSubmit, formState: { errors } } = useForm()

    const envParam = searchParams.get("env");

    const registerUser = async (token, displayName) => {
        return fetch(`${import.meta.env.VITE_STORE_DEPLOYMENT_API_URL}/users?display_name=${displayName}`, {
            method: 'PATCH',
            headers: new Headers({
                "Authorization": "Bearer " + token,
            })
        })
    }

    const onSubmit = async (data) => {

        const env = envParam ? envParam : "prod";
        data.environment = env.toLowerCase()

        if (!SENSEI_BACKEND_ENVS.includes(data.environment)) {
            setErrorMessage("Invalid environment")
            setShowErrorAlert(true)
            return;
        }

        data.appCode = SENSEI_AUTH_APP_CODE
        const requestOptions = {
            method: 'POST',
            headers: new Headers({
                "Content-type": "application/json",
            }),
            credentials: "include",
            body: JSON.stringify(data)
        }
        try {
            const response = await fetch(`${BuildSenseiAuthURL(data.environment)}/login`, requestOptions)
            const response_data = await response.json()
            if (response.ok) {
                localStorage.setItem("sensei-user-token", response_data.accessToken)
                localStorage.setItem("sensei-refresh-token", response_data.refreshToken)
                localStorage.setItem("sensei-user-name", response_data.user.loginName)
                localStorage.setItem("sensei-user-id", response_data.user.id)
                localStorage.setItem("sensei-user-env", data.environment)
                await registerUser(response_data.accessToken, response_data.user.name)
                setToken(response_data.accessToken)
                setRefreshToken(response_data.refreshToken)
            } else {
                setErrorMessage(response_data.message)
                setShowErrorAlert(true)
            }
        } catch {
            setErrorMessage("Unknown error!")
            setShowErrorAlert(true)
        }
    }

    return (
        <div className="container d-flex flex-column justify-content-center align-items-center min-vh-100">
            <img
                src="/sensei-logo-yellow.png" alt="logo" className="position-absolute start-50 translate-middle-x fade-in"
                style={{ zIndex: "10", width: "200px", height: "36px", top: "calc(50% - 295px)" }}
            />
            <Card className="w-100" style={{ maxWidth: "390px" }}>
                <Card.Body>
                    <Card.Title className="mb-4 text-center fs-2 fw-bold title-font">Store Deployments</Card.Title>
                    <Form noValidate onSubmit={handleSubmit(onSubmit)}>
                        <Form.Group controlId="form.Username" className="mb-4">
                            <Form.Label>Username:</Form.Label>
                            <Form.Control className="border-secondary shadow-sm" type="text" placeholder="Enter username" autoFocus  {...register("username", { required: true })} isInvalid={errors.username} />
                            <Form.Control.Feedback type="invalid">
                                Please fill in a valid value.
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="mb-4" controlId="form.Password">
                            <Form.Label>Password:</Form.Label>
                            <Form.Control className="border-secondary shadow-sm" type="password" placeholder="Password"  {...register("password", { required: true })} isInvalid={errors.password} />
                            <Form.Control.Feedback type="invalid">
                                Please fill in a valid value.
                            </Form.Control.Feedback>
                        </Form.Group>
                        {envParam &&
                            <Form.Group className="mb-4" controlId="form.Environment">
                                <Form.Label>Env:</Form.Label>
                                <Form.Control readOnly className="border-secondary shadow-sm" type="text" value={envParam} />
                            </Form.Group>}
                        {showErrorAlert &&
                            <Alert className="mb-4" variant="danger" onClose={() => setShowErrorAlert(false)} dismissible>
                                {errorMessage}
                            </Alert>}
                        <Button type="submit" variant="primary" className="w-100 mt-1">
                            Login
                        </Button>
                    </Form>
                </Card.Body>
            </Card>
        </div>
    )
}
